module.exports = __webpack_public_path__ + "img/Ute_Side_Left.cd2821b2.svg";